exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".history-entity pre[data-v-ecf48c46] {\n  padding: 0;\n  font-family: \"Source Sans Pro\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 16px;\n  white-space: pre-line;\n}\n.history-entity .timeline-body.removed[data-v-ecf48c46] {\n  opacity: 0.6;\n  background: #ffacac61;\n}", ""]);

// exports
